import React, { createContext, useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import axiosClient from '../api/axiosClient';
import { useToasts } from './ToastContext';
import { useAuth } from './AuthContext';

const PROGRAM_ROLES = ['Program Director', 'Instructor', 'Program Coordinator'];

const ProgramContext = createContext();

export const useProgram = () => useContext(ProgramContext);

export const ProgramProvider = ({ children }) => {
  const [programs, setPrograms] = useState([]);
  const [selectedProgramId, setSelectedProgramId] = useState(null);
  const { showToast } = useToasts();
  const { role } = useAuth();

  const refreshPrograms = useCallback(() => {
    if (!PROGRAM_ROLES.includes(role)) return;

    axiosClient.get('/programs')
      .then((response) => {
        const data = response.data?.programs || [];
        setPrograms(data);
        setSelectedProgramId((prev) => {
          if (prev && data.some((program) => program.id === prev)) {
            return prev;
          }
          return data.length > 0 ? data[0].id : null;
        });
      })
      .catch((error) => {
        showToast(error.message, 'error');
      });
  }, [role, showToast]);

  useEffect(() => {
    refreshPrograms();
  }, [refreshPrograms]);

  return (
    <ProgramContext.Provider value={{ programs, selectedProgramId, setSelectedProgramId, refreshPrograms }}>
      {children}
    </ProgramContext.Provider>
  );
};

ProgramProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
